var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WflowDesigner',{ref:"wfDesigner"})
}
var staticRenderFns = []

export { render, staticRenderFns }